import styled from 'styled-components';

import InputSimple, { nameDecorator, phoneDecorator } from '@r1-frontend/ui-react/components/inputSimple';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import Select from '@r1-frontend/ui-react/components/select/select';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

const InputPhone = phoneDecorator(InputSimple);
const InputName = nameDecorator(InputSimple);


export const InfoSection = styled.div`
    width: 100%;
    background-color: ${COLORS.BgSurface};
    flex-direction: column;
    padding: 24px;
    border-radius: ${BorderRadius.OuterBlockRadius};

    @media (max-width: ${wideBreakpoints.laptop}) {
        padding: 24px 8px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        padding: 20px;
        border-radius: ${BorderRadius.componentRadius};
    }
`;

export const InfoContainer = styled.div`
    flex-direction: column;
    position: relative;
    width: inherit;
    align-items: flex-start;
    margin-left: -4px;

    > div:first-child {
        background-color: ${COLORS.BgSubstrate};
        margin: 0 auto;
    }
`;

export const SPhoneInput = styled(InputPhone)<{ isNotFound?: boolean}>`
    margin-bottom: 10px;
    position: relative;
    margin-top: 16px;
    margin-left: 4px;

    input {
        background-image: url(/static/images/payments-abn/input-icon.svg);
        background-repeat: no-repeat;
        background-position: 95%;
    }
`;

export const StyledInput = styled(InputName)<{ isNotFound?: boolean}>`
    position: relative;
    margin-bottom: 10px;
    margin-top: 16px;
    margin-left: 4px;

    input {
        border-color: ${p => p.isNotFound ? COLORS.Logo : COLORS.BgSecondary} !important;
        background-image: url(/static/images/payments-abn/input-icon.svg);
        background-repeat: no-repeat;
        background-position: 95%;
    }
`;

export const NotFoundText = styled.p`
    ${FONTS.XXS};
    color: ${COLORS.Error};
    margin-top: -10px;
    margin-left: 4px;
`;

export const InfoLineTitle = styled.div`
    white-space: pre-wrap;
    ${FONTS.XS};
    margin-left: 8px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        padding-left: 16px;
        padding-right: 16px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        padding-left: 0;
        padding-right: 0;
    }
`;

export const Text = styled.p`
    ${FONTS.S};
    color: ${COLORS.TextSecondary};

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.XS};
    }
`;

export const FormGreyText = styled.div`
    ${FONTS.S};
    color: ${COLORS.TextSecondary};
    display: block;
`;

export const SSelect = styled(Select)`
    margin-top: 16px;
        
    > div > div:first-child > div {
        max-width: calc(100% - 30px);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 100%;
        display: inline;
        width: 100%;
    }

    div:nth-child(3) > div > div {
        padding: 16px;
        :hover {
            background-color: transparent;
        }
    }

    :nth-child(1) > div:first-child {
        border: 2px solid ${COLORS.GRAY_LIGHT};
        div > div {
            ${FONTS.XS};
        }
    }   
`;
